module.exports = __webpack_public_path__ + "img/orderbook.34ffde97.svg";